import { DismissIcon } from '@ps/web-shared-components';
import React, { useState } from 'react';

import Alert from '../../../../../Alert/Alert';
import DocumentsPreview from '../../../../../Prompts/DocumentsPreview/DocumentsPreview';

import { preview, wrapper } from './UploadSuccess.scss';

interface Props {
  acceptedFile: File;
  allFiles: File[];
  onDelete: () => void;
}

const UploadSuccess: React.FC<Props> = ({ acceptedFile, allFiles, onDelete }) => {
  const [showDocumentsPreviewPrompt, setDocumentsPreviewPrompt] = useState<boolean>(false);
  const handleOnDelete = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    onDelete();
  };
  return (
    <>
      <div onClick={() => setDocumentsPreviewPrompt(true)}>
        <Alert variant="success" className={wrapper}>
          <span className={preview}>{acceptedFile.name}</span>
          <DismissIcon onClick={handleOnDelete} />
        </Alert>
      </div>
      {showDocumentsPreviewPrompt && (
        <DocumentsPreview
          acceptedFile={acceptedFile}
          allFiles={allFiles}
          onClose={() => setDocumentsPreviewPrompt(false)}
        />
      )}
    </>
  );
};

export default UploadSuccess;
